import { useCallback } from 'react';
import useCustomizeCarContext from '../useCustomizeCarContext';
import CategoryPurpose from '../../enum/CategoryPurpose';
import usePlatformConfig from '../../../common/react/usePlatformConfig';
import { updateDxpDataLayer } from '../../../../../common/utilities/dxpDigitalDataAssignment';
import { DxpDataLayerEventNames } from '../../../../../common/utilities/customDatalayerInterface';
import { selectedAccessories } from '../../../gqlCommon/graphql/cache';
import CategoryFeatureTypes from '../../enum/CategoryFeatureTypes';
import useDxpDataLayer from '../../../common/hooks/useDxpDataLayer';

export const useCheckSelectedFeatures = () => {
  const { toggleFeature } = useCustomizeCarContext();
  const { platformConfig } = usePlatformConfig();

  const { model, motor, versions, interiorColor, exteriorColor } = useDxpDataLayer();
  const handleCheckboxChange = useCallback(
    (code: string, category?: string, featureName?: string) => {
      toggleFeature(code);
      if (category && platformConfig?.dxpDataLayer) {
        if (category === CategoryPurpose.ACCESSORY) {
          const accessories = updateDxpDataLayer(
            {
              eventName: DxpDataLayerEventNames.CONFIGURATOR_ACCESSORIES,
              model,
              motor,
              versions,
              interiorColor,
              exteriorColor,
            },
            CategoryFeatureTypes.ACCESSORIES,
            featureName,
          );
          selectedAccessories(accessories);
        }
      }
    },
    [toggleFeature, interiorColor, exteriorColor, versions],
  );

  return { handleCheckboxChange };
};
